import { useCallback } from 'react';
import { Box, ButtonBase, InputBase, makeStyles } from '@material-ui/core';
import { MinusIcon, PlusIcon } from '../../../../../components/Icon';
import { classNames, initValue } from '../../../../../utils';
const useStyles = makeStyles(() => ({
  icon: {
    color: '#538fff',
  },
  inputNum: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: '#3e3e3e',
    borderLeft: '1px solid #e4e7eb',
    borderRight: '1px solid #e4e7eb',
    '&>input': {
      textAlign: 'center',
    },
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5',
    },
  },
  buttonBtn: {
    width: '3.5rem',
    height: '3.5rem',
    padding: '1.688rem 1.25rem',
    '&.Mui-disabled': {
      backgroundColor: '#e4e7eb',
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
      color: '#939393',
    },
  },
  buttonAddBtn: {
    width: '3.5rem',
    height: '3.5rem',
    padding: '1.688rem 1.25rem',
    '&.Mui-disabled': {
      backgroundColor: '#e4e7eb',
      borderTopRightRadius: '10px',
      borderBottomRightRadius: '10px',
      color: '#939393',
    },
  },
  symbol: {
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: '#2e4469',
    marginTop: '1.8rem',
  },
  iconDisabled: {
    color: '#939393',
  },
}));
const Counter = ({ onChange, value, width, style, inputBaseReadOnly = false }) => {
  const classes = useStyles();
  const reduceHandler = useCallback(() => {
    onChange(value - 1);
  }, [value, onChange]);
  const changeHandler = useCallback(
    (event) => {
      if (event.target.value < 1) {
        onChange(1);
      } else {
        onChange(Number(event.target.value));
      }
    },
    [onChange]
  );
  const addHandler = useCallback(() => {
    onChange(value + 1);
  }, [value, onChange]);
  return (
    <Box
      display="flex"
      border="solid 1px #e4e7eb"
      borderRadius="10px"
      p="0"
      height="3.5rem"
      justifyContent="space-between"
      width={initValue(width, '100%')}
      style={style}
    >
      <ButtonBase
        id="qty-reduce"
        onClick={reduceHandler}
        className={classes.buttonBtn}
        disabled={value === 1 || Boolean(inputBaseReadOnly)}
      >
        <MinusIcon className={classNames(classes.icon, (value === 1 || inputBaseReadOnly) && classes.iconDisabled)} />
      </ButtonBase>

      <InputBase
        id="qty-input"
        className={classes.inputNum}
        inputProps={{ type: 'number' }}
        onChange={changeHandler}
        value={value}
        disabled={inputBaseReadOnly}
      />

      <ButtonBase id="qty-add" onClick={addHandler} className={classes.buttonAddBtn} disabled={inputBaseReadOnly}>
        <PlusIcon className={classNames(classes.icon, inputBaseReadOnly && classes.iconDisabled)} />
      </ButtonBase>
    </Box>
  );
};
export default Counter;
